"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationStore = void 0;
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const AuthorizationScopes_1 = __importDefault(require("../enums/AuthorizationScopes"));
const auth0_1 = require("../helper/auth0");
const sentry_1 = require("../helper/sentry");
class AuthorizationStore {
    internalAuth0 = null;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalAuth0: mobx_1.observable,
            auth0: mobx_1.computed,
            user: mobx_1.computed,
            claims: mobx_1.computed,
            language: mobx_1.computed,
            country: mobx_1.computed,
            currency: mobx_1.computed,
            contactSalutation: mobx_1.computed,
            contactName: mobx_1.computed,
            contactId: mobx_1.computed,
            customerName: mobx_1.computed,
            customerId: mobx_1.computed,
            originalCustomerId: mobx_1.computed,
            customerType: mobx_1.computed,
            channelId: mobx_1.computed,
            scopes: mobx_1.computed,
            industryId: mobx_1.computed,
            setAuth0: mobx_1.action.bound,
        });
        (0, mobx_1.reaction)(() => {
            return this.originalCustomerId;
        }, (currentOriginalCustomerId) => {
            (0, sentry_1.setSentryUser)(currentOriginalCustomerId ? { id: currentOriginalCustomerId } : null);
        });
    }
    get auth0() {
        return this.internalAuth0;
    }
    get user() {
        return (0, auth0_1.getUser)(this.internalAuth0);
    }
    get claims() {
        return (0, auth0_1.getClaims)(this.internalAuth0);
    }
    get language() {
        return this.claims?.language ?? null;
    }
    get country() {
        return this.claims?.country ?? null;
    }
    get currency() {
        return this.claims?.currency ?? null;
    }
    get contactSalutation() {
        return this.claims?.salutation ?? null;
    }
    get contactName() {
        return this.claims?.name ?? null;
    }
    get contactId() {
        return this.claims?.contactId ?? null;
    }
    get customerName() {
        return this.claims?.customerName ?? null;
    }
    get customerId() {
        return this.claims?.customerId ?? null;
    }
    get originalCustomerId() {
        return this.claims?.originalCustomerId ?? null;
    }
    get customerType() {
        return this.claims?.customerType ?? null;
    }
    get channelId() {
        return this.claims?.channelId ?? null;
    }
    get scopes() {
        return Object.values(AuthorizationScopes_1.default);
    }
    get industryId() {
        return this.claims?.industryId ?? null;
    }
    setAuth0(auth0) {
        this.internalAuth0 = auth0;
    }
    hasScope(scope) {
        return this.hasScopes([scope]);
    }
    hasScopes(scopes) {
        const claimedScopes = this.claims?.scope ?? [];
        return scopes.every((scope) => claimedScopes.includes(scope));
    }
    hasAnyScope(scopes) {
        const claimedScopes = this.claims?.scope ?? [];
        return scopes.some((scope) => claimedScopes.includes(scope));
    }
}
exports.AuthorizationStore = AuthorizationStore;
__decorate([
    bind_decorator_1.default
], AuthorizationStore.prototype, "hasScope", null);
__decorate([
    bind_decorator_1.default
], AuthorizationStore.prototype, "hasScopes", null);
__decorate([
    bind_decorator_1.default
], AuthorizationStore.prototype, "hasAnyScope", null);
exports.default = new AuthorizationStore();
